// extracted by mini-css-extract-plugin
export var heading = "Logos-module--heading--18f1d";
export var logos = "Logos-module--logos--1c874";
export var section = "Logos-module--section--4adc9";